export default "__VITE_ASSET__b2153f85__"